import { render, staticRenderFns } from "./CheckoutThankYou.vue?vue&type=template&id=7ff445bc&"
import script from "./CheckoutThankYou.vue?vue&type=script&lang=js&"
export * from "./CheckoutThankYou.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports